import {useState} from "react";
import {FormContainer, Layout} from "../../../../../palette/Palette";
import Text from "../../../../../palette/Text";
import VerticalSpace from "../../../../../palette/VerticalSpace";
import HeaderPage from "../../../../../palette/HeaderPage";
import MapParcelManual from "./MapParcelManual";
import DirectionRoutes from "./DirectionRoutes";
import {useJsApiLoader} from "@react-google-maps/api";
import {Button} from "devextreme-react/button";
import Alerts from "../../../../../palette/Alerts";
import RoutesDrivers from "./RoutesDrivers";
import {Animated} from "react-animated-css";
import Details from "./Details";

const {REACT_APP_GM_KEY} = process.env

function Parcels(props) {

    const {DataStore, dataPassengers, setVisibleGrid, setReservationManual, viewport, setViewport, setParcels} = props;
    const {
        companyName, idCompany, providerPercentage, tripStartControl, bookingAnticipation, contactNumbers,
        vehicleDisplay
    } = DataStore

    const [dataCoords, setDataCoords] = useState(null);
    const [routesControl, setRouteControl] = useState({origenCity: null, destinyCity: null});
    const [routesExist, setRouteExist] = useState(true);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [valueDate, setValueDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(null);
    const [getCoordsClient, setGetCoordsClient] = useState(null);
    const [restrict, setRestrict] = useState(false);
    const [hour, setHour] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [total, setTotal] = useState(0);
    const [driver, setDriver] = useState('');
    const [exists, setExists] = useState(false);
    const [driverId, setDriverId] = useState(null);
    const [vehicleData, setVehicleData] = useState(null);
    const [tokenPush, setTokenPush] = useState(null);
    const [showBackBtn, setShowBackBtn] = useState(true);
    const [showBounds, setShowBounds] = useState(false);
    const [photo, setPhoto] = useState(null);
    const [clickControl, setClickControl] = useState(true);

    const {isLoaded} = useJsApiLoader({
        googleMapsApiKey: REACT_APP_GM_KEY,
        libraries: ["places"],
        region: 'EC'
    })

    const reservationName = `Encomienda para ${dataPassengers.name} ${dataPassengers.lastName}`

    const routeName = `${routesControl.origenCity}-${routesControl.destinyCity}`;

    const backButton = () => {
        return (
            <Button icon="far fa-arrow-alt-circle-left" text="Volver" width={110}
                    onClick={() => {
                        setVisibleGrid(true)
                        setParcels(false)
                    }}
            />
        )
    }

    const GetCoordsClient = () => {
        setShowBounds(true)
        setShowBackBtn(false)
        setShowCalendar(true);
        setGetCoordsClient(dataCoords);
    }

    return (
        <>
            <div className="reservation-container">
                {(viewport && isLoaded) &&
                <div className="map-container">
                    <HeaderPage icon={'fas fa-map-marked-alt'} text={reservationName} load={true}/>
                    <FormContainer>
                        <MapParcelManual dataCoords={dataCoords} setGetCoordsClient={setGetCoordsClient}
                                         setDataCoords={setDataCoords} restrict={restrict}
                                         setRestrict={setRestrict} setShowBackBtn={setShowBackBtn}
                                         getCoordsClient={getCoordsClient} DataStore={DataStore}
                                         setShowCalendar={setShowCalendar} showBounds={showBounds}
                                         routesExist={routesExist} routesControl={routesControl}
                                         setShowBounds={setShowBounds} setViewport={setViewport}
                                         viewport={viewport} clickControl={clickControl} showCalendar={showCalendar}/>
                    </FormContainer>
                </div>}

                {(viewport && isLoaded) &&
                <div className="data-container">
                    <Layout>
                        <Text hover={false} text={'Direcciones'} size={14} color="#19598D" weight={'700'}/>
                    </Layout>
                    <VerticalSpace space={10}/>

                    <DirectionRoutes setDataCoords={setDataCoords} dataCoords={dataCoords} DataStore={DataStore}
                                     setRouteControl={setRouteControl} routesControl={routesControl}
                                     setRouteExist={setRouteExist} setSelectedItemKeys={setSelectedItemKeys}
                                     setShowCalendar={setShowCalendar} setValueDate={setValueDate}
                                     setClickControl={setClickControl} setClickControl={setClickControl}/>

                    <VerticalSpace space={7}/>

                    {(routesExist && !restrict && showBackBtn) && backButton()}

                    {!routesExist &&
                    <>
                        <Alerts severity="error" body={`No existen viajes dede ${routeName}`}/>
                        <VerticalSpace space={5}/>
                        {backButton()}
                    </>
                    }

                    {restrict &&
                    <>
                        <Alerts severity="error" body={'No hay cobertura para esta zona!'}/>
                        <VerticalSpace space={5}/>
                        {backButton()}
                    </>}

                    {(!restrict && routesExist && !showBackBtn && !showCalendar) &&
                    <Layout center space row>
                        {backButton()}
                        <Button icon="far fa-check-circle" type="success" text="Aceptar ruta" width={150}
                                onClick={GetCoordsClient}
                        />
                    </Layout>}

                    <VerticalSpace space={10}/>
                    {showCalendar &&
                    <Text hover={false} text={'Rutas y horarios'} size={14} color="#19598D" weight={'700'}/>}
                    <VerticalSpace space={10}/>
                    {showCalendar &&
                    <RoutesDrivers
                        getCoordsClient={getCoordsClient} companyName={companyName} setPhoto={setPhoto}
                        idCompany={idCompany} hour={hour} setDataList={setDataList}
                        setSelectedItemKeys={setSelectedItemKeys} showCalendar={showCalendar}
                        selectedItemKeys={selectedItemKeys} dataList={dataList} total={total}
                        setTotal={setTotal} valueDate={valueDate} setVehicleData={setVehicleData}
                        setValueDate={setValueDate} driverId={driverId} setDriverId={setDriverId}
                        setHour={setHour} setExists={setExists} exists={exists} setDriver={setDriver}
                        bookingAnticipation={bookingAnticipation} setTokenPush={setTokenPush}
                        vehicleDisplay={vehicleDisplay} setVisibleGrid={setVisibleGrid} setParcels={setParcels}
                    />
                    }
                </div>}
            </div>

            <VerticalSpace space={12}/>
            {selectedItemKeys.length > 0 &&
            <div className="reservation-container">
                <div className="details-container">
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <Details setParcels={setParcels} total={total} vehicleData={vehicleData} hour={hour}
                                 valueDate={valueDate} exists={exists} dataPassengers={dataPassengers}
                                 getCoordsClient={getCoordsClient} driver={driver} setVisibleGrid={setVisibleGrid}
                                 providerPercentage={providerPercentage} DataStore={DataStore}
                                 contactNumbers={contactNumbers} tokenPush={tokenPush} photo={photo}
                                 tripStartControl={tripStartControl}/>
                    </Animated>
                </div>
                <div/>
            </div>}
        </>
    )
}

export default Parcels;
